<p class="mb-2">
  <strong>{{ client?.name }}</strong>
</p>
<p class="mb-2" *ngIf="!!client?.address">
  {{ client.address }}
</p>
<p class="mb-2" *ngIf="!!client?.address2">
  {{ client.address2 }}
</p>
<p
  class="mb-2"
  *ngIf="
    !!client?.city ||
    !!client?.zip
  "
>
  {{ client.zip }}
  {{ client.city }}
</p>
<p class="mb-2" *ngIf="!!client?.country">
  {{ client.country }}
</p>
<p class="mb-2" *ngIf="!!client?.taxNumber">
  <span *ngIf="!!client.taxSubject"
    >{{ 'document-view-public.document-client.tax-id' | translate }}:</span
  >
  <span *ngIf="!client.taxSubject"
    >{{ 'document-view-public.document-client.tax-number' | translate }}:</span
  >
  <span id="org-tax_num-val">
    {{ client.taxNumber }}
  </span>
</p>

<!-- _data -->
<p
  class="mb-2"
  *ngFor="let d of client?._data"
>
  {{ d.name }}<span *ngIf="d.value">: {{ d.value }}</span>
</p>
